export default __webpack_public_path__ + "static/media/after@3x.d729f469.png";